import { Clock, Hourglass, Eye, PauseCircle, CheckCircle2, XCircle, CalendarClock } from "lucide-react";
import { stageOf } from "@/lib/format";

const ICONS = { clock: Clock, hourglass: Hourglass, eye: Eye, pause: PauseCircle, check: CheckCircle2, x: XCircle, calendar: CalendarClock };

export default function StageBadge({ referral, days }) {
  const s = stageOf(referral);
  const Icon = ICONS[s.icon] || Clock;
  return (
    <span
      title={s.hint}
      data-testid={`stage-badge-${referral?.id ?? "x"}`}
      className={`inline-flex items-center gap-1.5 rounded-md border px-2 py-0.5 text-xs font-medium ${s.cls}`}
    >
      <Icon className="w-3.5 h-3.5 shrink-0" />
      <span className="whitespace-nowrap">{s.label}</span>
      {days != null && <span className="font-mono opacity-70 tnum">· {days}d</span>}
    </span>
  );
}
